// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"969bb3128417ca33","623":"1dde9da0e9a1d1b5","888":"2f6af3d3aa466fde"}[chunkId] + ".css";
};